import React from 'react';

export const ConnexionEnvironnementsTab = ({ data, setData }) => {
  const updateField = React.useCallback((field, value) => {
    setData(prev => ({
      ...prev,
      connexionEnvironnements: {
        ...prev.connexionEnvironnements,
        [field]: value
      }
    }));
  }, [setData]);

  return (
    <div className="space-y-8">
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <p className="text-sm text-blue-800">
          <strong>Note :</strong> Nous devons retrouver la procédure complète permettant à toute personne de se connecter aux environnements
        </p>
      </div>

      {/* Informations générales */}
      <div>
        <h3 className="text-lg font-semibold text-blue-700 mb-4 border-b border-blue-200 pb-2">
          Informations générales
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Modules vendus
            </label>
            <textarea
              value={data.modulesVendus || ''}
              onChange={(e) => updateField('modulesVendus', e.target.value)}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Options (ex: rappels rdv, reprise historique)
            </label>
            <textarea
              value={data.options || ''}
              onChange={(e) => updateField('options', e.target.value)}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Type d'hébergement
            </label>
            <select
              value={data.typeHebergement || ''}
              onChange={(e) => updateField('typeHebergement', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Sélectionner un type</option>
              <option value="onpremise">On-Premise</option>
              <option value="cloud">Cloud (AZ Networks)</option>
              <option value="hybride">Hybride</option>
            </select>
          </div>
        </div>
      </div>

      {/* Checklist */}
      <div>
        <h3 className="text-lg font-semibold text-green-700 mb-4 border-b border-green-200 pb-2">
          Checklist
        </h3>
        <div className="space-y-3">
          <div className="flex items-center p-3 border border-gray-200 rounded-lg">
            <input
              type="checkbox"
              id="checklistBitwarden"
              checked={data.checklistBitwarden || false}
              onChange={(e) => updateField('checklistBitwarden', e.target.checked)}
              className="mr-3 h-5 w-5 text-blue-600 rounded"
            />
            <label htmlFor="checklistBitwarden" className="flex-1 cursor-pointer">
              <span className="font-medium">Les informations utiles pour se connecter sont-elles dans Bitwarden ?</span>
            </label>
          </div>
          <div className="flex items-center p-3 border border-gray-200 rounded-lg">
            <input
              type="checkbox"
              id="checklistContacts"
              checked={data.checklistContacts || false}
              onChange={(e) => updateField('checklistContacts', e.target.checked)}
              className="mr-3 h-5 w-5 text-blue-600 rounded"
            />
            <label htmlFor="checklistContacts" className="flex-1 cursor-pointer">
              <span className="font-medium">Les contacts utiles sont-ils renseignés dans le dossier d'ingénierie ?</span>
            </label>
          </div>
        </div>
      </div>

      {/* Process de connexion */}
      <div>
        <h3 className="text-lg font-semibold text-purple-700 mb-4 border-b border-purple-200 pb-2">
          Process de connexion
        </h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Comment se connecter
            </label>
            <textarea
              value={data.processConnexion || ''}
              onChange={(e) => updateField('processConnexion', e.target.value)}
              rows="5"
              placeholder="-- Process à rédiger --"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Restrictions réseau (IP...etc)
            </label>
            <textarea
              value={data.restrictionsReseau || ''}
              onChange={(e) => updateField('restrictionsReseau', e.target.value)}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* Section d'aide */}
      <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h4 className="font-semibold text-gray-800 mb-3">Informations à documenter :</h4>
        <ul className="list-disc list-inside space-y-2 text-sm text-gray-600">
          <li>URLs d'accès pour chaque environnement (Production, Qualification)</li>
          <li>Procédure de connexion VPN si nécessaire</li>
          <li>Identifiants et mots de passe (à stocker dans Bitwarden)</li>
          <li>Contacts techniques du client (DSI, responsable infrastructure)</li>
          <li>Horaires d'accès autorisés</li>
          <li>Restrictions IP ou autres contraintes réseau</li>
          <li>Procédure d'escalade en cas de problème d'accès</li>
        </ul>
      </div>
    </div>
  );
};